import Layout from '@/layout'
const routesMap = {
  layout: Layout,
  product:()=>import('@/views/product/onlineManage'),
  productOnlineManage:()=>import('@/views/product/onlineManage'),//线上商品管理
  productUnderManage:()=>import('@/views/product/underManage'),//线下商品管理
  productDraft:()=>import('@/views/product/draft'),//线上草稿管理
  productCombination:()=>import('@/views/product/combination'),//组合商品
  productOnlineReview:()=>import('@/views/product/onlineProReview'),//线上商品审核
  productSettle:()=>import('@/views/product/productSettle/productSettleList'),//费率设置
  productSettleDetail:()=>import('@/views/product/productSettle/productSettleDetail'),//费率设置商品详情
  addOnLineProduct:()=>import('@/views/product/addOnLineProduct'),//新增线上商品

  seller:()=>import('@/views/seller/sellerList'),//商户管理
  sellerList:()=>import('@/views/seller/sellerList'),//商户管理
  sellerApprove:()=>import('@/views/seller/sellerApprove'),//商户审批
  arrears:()=>import('@/views/seller/arrears'),            //欠款管理
  sellerSubordinate:()=>import('@/views/seller/subordinate'),//子商户管理
  sellerRelation:()=>import('@/views/seller/relation'),//商户关系管理
  shopMemberCard:()=>import('@/views/seller/shopMemberCard'),//商户会员卡管理

  operation:()=>import('@/views/operation/liveBroadcast'),//运营管理start
  liveBroadcast:()=>import('@/views/operation/liveBroadcast'),
  socialGroup:()=>import('@/views/operation/socialGroup'),
  socialGroupDynamic:()=>import('@/views/operation/socialGroupDynamic'),
  depositList:()=>import('@/views/operation/depositList'),   //保证金管理
  depositDetail:()=>import('@/views/operation/depositDetail'),   //保证金详情
  shortActivity:()=>import('@/views/operation/shortActivity'), // 燊鲜GO
  summaryData:()=>import('@/views/operation/summaryData'),  // 汇总数据
  blackList:()=>import('@/views/operation/blackList'), // 黑名单维护
  priceContrast:()=>import('@/views/operation/priceContrast'),//商品价格对比表
  memberList:()=>import('@/views/memberManage/memberList'),//会员管理start
  memberDetail:()=>import('@/views/memberManage/memberDetail'),
  memberPoint:()=>import('@/views/memberManage/memberPoint'),
  memberSettle:()=>import('@/views/memberManage/memberSettle'), //会员入驻
  memberAuthentica:()=>import('@/views/memberManage/memberAuthentica'),
  memberAuditDetail:()=>import('@/views/memberManage/memberAuditDetail'),
  manageType:()=>import('@/views/memberManage/manageType'),
  reportConfig:()=>import('@/views/memberManage/reportConfig'),
  assetManage:()=>import('@/views/assetManage/billManage'), //资产管理start
  settleManage:()=>import('@/views/assetManage/settleManage'),
  reconciManage:()=>import('@/views/assetManage/reconciManage'),
  billManage:()=>import('@/views/assetManage/billManage'),
  feeManage:()=>import('@/views/assetManage/feeManage'),//费用管理
  withdrawManage:()=>import('@/views/assetManage/withdrawManage'),
  userRechargeOrder:()=>import('@/views/assetManage/userRechargeOrder'),
  userCashTopUp:()=>import('@/views/assetManage/userCashTopUp'),
  reportDownload:()=>import('@/views/assetManage/reportDownload'),
  summaryManagement: ()=>import('@/views/assetManage/summaryManagement'),
  topUpOrderCancel: ()=>import('@/views/assetManage/topUpOrderCancel'),
  redRush:()=>import('@/views/orderManage/redRush'), // 红冲
  reductionManage:()=>import('@/views/assetManage/reductionManage'), // 红冲审核
  staBalance:()=>import('@/views/assetManage/staBalance'),
  staSettle:()=>import('@/views/assetManage/staSettle'),
  marketingExpenseBill:()=>import('@/views/assetManage/marketingExpenseBill'),
  shopWithdraw:()=>import('@/views/assetManage/shopWithdraw'),
  invoicingAuditList:()=>import('@/views/assetManage/invoicingAuditList'),
  invoicingDetail:()=>import('@/views/assetManage/invoicingDetail'),
  withdrawMonitor:()=>import('@/views/assetManage/withdrawMonitor'), // 提现监控大盘
  //营销管理start
  activityList:()=>import('@/views/marketingManage/activityList'),
  activityAuditList:()=>import('@/views/marketingManage/activityAuditList'),
  redpacketList:()=>import('@/views/marketingManage/redpacketList'),
  redpacketAuditList:()=>import('@/views/marketingManage/redpacketAuditList'),
  redpacketTrackList:()=>import('@/views/marketingManage/redpacketTrackList'),
  couponsList:()=>import('@/views/marketingManage/couponsList'),
  couponsAuditList:()=>import('@/views/marketingManage/couponsAuditList'),
  couponsTrackList:()=>import('@/views/marketingManage/couponsTrackList'),
  issueList:()=>import('@/views/marketingManage/issueList'),
  issueAuditList:()=>import('@/views/marketingManage/issueAuditList'),
  couponList:()=>import('@/views/marketingManage/newCoupon/couponList'),
  addCoupon:()=>import('@/views/marketingManage/newCoupon/addCoupon'),
  couponActivity:()=>import('@/views/marketingManage/newCoupon/couponActivity'),
  addActivity:()=>import('@/views/marketingManage/newCoupon/addActivity'),
  editActivity:()=>import('@/views/marketingManage/newCoupon/editActivity'),
  drawCouponList:()=>import('@/views/marketingManage/newCoupon/drawCouponList'),
  marketingFee:()=>import('@/views/marketingManage/newCoupon/marketingFee'),
  pointsList:()=>import('@/views/marketingManage/points/pointsList'),   //积分活动
  pointsAdd:()=>import('@/views/marketingManage/points/add'),          //积分活动新增
  buyGiftList:()=>import('@/views/marketingManage/buyGift/actList'),  //买赠活动
  buyGiftRules:()=>import('@/views/marketingManage/buyGift/actRules'),  //活动规则
  rebateAct:()=>import('@/views/marketingManage/rebate/rebateActList'),  //返利活动
  markupList:()=>import('@/views/marketingManage/markupPur/markupList'),  //加价购
  markupAdd:()=>import('@/views/marketingManage/markupPur/markupAdd'),  //加价购新增
  secKillAct:()=>import('@/views/marketingManage/secKill/secKillAct'),  //秒杀活动
  secKillTime:()=>import('@/views/marketingManage/secKill/secKillTime'),//秒杀时间配置
  secKillAdd:()=>import('@/views/marketingManage/secKill/secKillAdd'),  //新增秒杀活动
  getCouponActivity:()=>import('@/views/marketingManage/getCouponAct/getCouponActList'),//领券活动
  getCouponActAdd:()=>import('@/views/marketingManage/getCouponAct/getCouponActAdd'),//新增领券活动
  promoRecommend:()=>import('@/views/marketingManage/recommend/recommendList'),  //推荐管理
  promoRecommendProduct:()=>import('@/views/marketingManage/recommend/recommendProduct'),  //推荐维护商品
  actProductPageConfig:()=>import('@/views/marketingManage/actProductPageConfig/actProductPageConfigList'),  //活动商品页面配置
  actProductPageConfigAdd:()=>import('@/views/marketingManage/actProductPageConfig/actProductPageConfigAdd'), //新增活动商品页面配置
  //营销管理end

  sysCategory:()=>import('@/views/category/sysCategory'),
  virtualCategory:()=>import('@/views/category/virtualCategory'),
  sys:()=>import('@/views/sysManage/roleList'),
  menuList:()=>import('@/views/sysManage/menuList'),
  roleList:()=>import('@/views/sysManage/roleList'),
  adminList:()=>import('@/views/sysManage/adminList'),
  shopAdminListManage:()=>import('@/views/sysManage/shopAdminListManage'),
  accountList:()=>import('@/views/sysManage/accountList'),
  logisticsList:()=>import('@/views/sysManage/logisticsList'),
  specialCommoditySettlement:()=>import('@/views/sysManage/specialCommoditySettlement'),
  whiteList:()=>import('@/views/sysManage/whiteList'),
  msgList:()=>import('@/views/sysManage/msgList'),
  delayList: ()=>import('@/views/sysManage/delayList'),// 定时器补偿}
  afterWhyList:()=>import('@/views/sysManage/afterWhyList'),
  businessConfig:()=>import('@/views/sysManage/businessConfig'),
  warehouse:()=>import('@/views/sysManage/warehouse'),
  productIssues:()=>import('@/views/sysManage/productIssues'), //商品问题配置
  keyConfig:()=>import('@/views/sysManage/keyConfig'), //重点商户商品配置
  config:()=>import('@/views/configManage/configList'),
  configList:()=>import('@/views/configManage/configList'),
  placeList:()=>import('@/views/configManage/placeList'),
  faqList:()=>import('@/views/configManage/faqList'), // 常见问题管理
  searchList:()=>import('@/views/configManage/searchList'), // 搜索配置
  agreementList:()=>import('@/views/configManage/agreementList'), // 协议管理
  reprintReason:()=>import('@/views/configManage/reprintReason'), // 补打原因配置
  tagList:()=>import('@/views/configManage/tagList'), // 标签配置
  deliveryManager:()=>import('@/views/configManage/deliveryManager'), // 配送管理
  purchaseConfig:()=>import('@/views/configManage/purchaseConfig'), // 采小助配置
  sundry:()=>import('@/views/configManage/sundry'), // 杂项配置
  popularManager:()=>import('@/views/configManage/popularManager'), //热门行情配置
  marketConfig:()=>import('@/views/configManage/marketConfig'),  // 市场行情配置
  aftersale: ()=>import('@/views/aftersale/aftersaleOrder'), // 售后管理
  aftersaleOrder: ()=>import('@/views/aftersale/aftersaleOrder'),
  refundOrder: ()=>import('@/views/aftersale/refundOrder'),
  orderManage: ()=>import('@/views/orderManage/cityWholesalerOrder'),
  cityWholesalerOrder: ()=>import('@/views/orderManage/cityWholesalerOrder'),
  cityDetailNew: ()=>import('@/views/orderManage/cityDetailNew'),
  originDealerOrder: ()=>import('@/views/orderManage/originDealerOrder'),
  warehouseOrderList: ()=>import('@/views/orderManage/warehouseOrderList'), //仓库单列表
  arrearsOrder:()=>import('@/views/seller/arrearsOrder'),   //欠款还款账单
  arrearsOrderDetail:()=>import('@/views/seller/arrearsOrderDetail'),//欠款还款账单详情
	pageConfig: ()=>import('@/views/pageConfig/floorConfig'),// 首页配置
  floorConfig: ()=>import('@/views/pageConfig/floorConfig'),// 首页楼层配置
  advertConfig: ()=>import('@/views/pageConfig/advertConfig'),// 广告图配置
  goodsRecommend: ()=>import('@/views/pageConfig/goodsRecommend'),// 商品推荐
  informationList: ()=>import('@/views/pageConfig/informationList'),// 资讯列表
  cateConfig: ()=>import('@/views/pageConfig/cateConfig'),// 小程序分类页配置
  guideCateConfig: ()=>import('@/views/pageConfig/guideCateConfig'),// 小程序购前指南分类页配置
  // 物流管理
  logisticsDelivery:()=>import('@/views/logisticsDelivery/logisticsOrderManag'),
  logisticsOrderManag:()=>import('@/views/logisticsDelivery/logisticsOrderManag'), //物流订单管理
  transferDistribution:()=>import('@/views/logisticsDelivery/transferDistribution'),  //中转仓分配
  printDispatch:()=>import('@/views/logisticsDelivery/printDispatch'), //  补打派送清单
  freightManage:()=>import('@/views/logisticsDelivery/freightManage'),  //运费配送
  thermodynamicDiagram:()=>import('@/views/logisticsDelivery/thermodynamicDiagram'),  //运费配送
  thermData:()=>import('@/views/logisticsDelivery/thermData'),  //运费配送
  scanIndex:()=>import('@/views/logisticsDelivery/scanIndex'),
  quickAllocation:()=>import('@/views/logisticsDelivery/quickAllocation'),  //快捷分配
  orderLogistics:()=>import('@/views/logisticsDelivery/orderLogistics'),  //订单物流
  addressModify:()=>import('@/views/logisticsDelivery/addressModify'),  //中转仓管理（地址修正）
  alreadyAssigned:()=>import('@/views/logisticsDelivery/alreadyAssigned'),  //已分配司机订单
  alreadyAssignedDetail:()=>import('@/views/logisticsDelivery/alreadyAssignedDetail'),  //已分配司机订单详情
  mapIndex:()=>import('@/views/logisticsDelivery/mapIndex'),  //移动轨迹
  shopCombination:()=>import('@/views/logisticsDelivery/shopCombination'),  //自定义商户组合
  addressUpdateAudit:()=>import('@/views/logisticsDelivery/addressUpdateAudit'),  //地址修正审核
  spotCheckIndex:()=>import('@/views/logisticsDelivery/spotCheckIndex'),

  //物流费用规则
  logisticsCostRule:()=>import('@/views/logisticsCostRule/areaList'),
  areaList:()=>import('@/views/logisticsCostRule/areaList'),   //外围区域设置
  modelList:()=>import('@/views/logisticsCostRule/modelList'),  //车型维护
  costRuleList:()=>import('@/views/logisticsCostRule/costRuleList'),  //费用规则维护
  driverRuleList:()=>import('@/views/logisticsCostRule/driverRuleList'),  //司机绑定
  costCustomList:()=>import('@/views/logisticsCostRule/costCustomList'),   //自定义费用
  costStatistics:()=>import('@/views/logisticsCostRule/costStatistics'),  //费用统计


  // 页面配置
  businessCircleNews:()=>import('@/views/pageConfig/businessCircleNews'),  //生意圈资讯
  // 客户管理
  clientManage:()=>import('@/views/clientManage/relationManage'),
  relationManage:()=>import('@/views/clientManage/relationManage'), // 客户关系管理
  promoterManage:()=>import('@/views/clientManage/promoterManage'), // 推广员管理

  //业务员管理
  businessManager:()=>import('@/views/clientManage/promoterManage'),
  business:()=>import('@/views/clientManage/promoterManage'),   //推广员
  lsManager:()=>import('@/views/businessManager/lsManager'),   //物流员
  councilManager:()=>import('@/views/businessManager/councilManager'), //场内理事
  //采小助商品管理
  purchaseHelper:()=>import('@/views/purchaseHelper/purchaseCategory'),
  purchaseCategory:()=>import('@/views/purchaseHelper/purchaseCategory'), //采小助分类管理
  purchaseRecommend:()=>import('@/views/purchaseHelper/purchaseRecommend'), //采小助商品推荐
  purchaseSummary:()=>import('@/views/purchaseHelper/purchaseSummary'), //采小助汇总管理
  unrecordedSummary:()=>import('@/views/purchaseHelper/unrecordedSummary'), //未录入汇总
  quotationManage:()=>import('@/views/purchaseHelper/quotationManage'), //报价单管理

  //CRM工单相关
  visitManage:()=>import('@/views/visitManage/workOrderManage'),
  workOrderManage:()=>import('@/views/visitManage/workOrderManage'), // 拜访工单管理
  askConfig:()=>import('@/views/visitManage/askConfig'), // 工单问询配置

  // 报表管理
  reportList:()=>import('@/views/reportList/superMember'),
  superMember:()=>import('@/views/reportList/superMember'), //超级会员日
  blackListMember:()=>import('@/views/reportList/blackListMember'), //超级会员日  黑名单
  superMemberShang:()=>import('@/views/reportList/superMemberShang'), //超级会员日(商户)
  treatyList:()=>import('@/views/reportList/treatyList'),           //协议管理
  treatyAudit:()=>import('@/views/reportList/treatyAudit'),    //协议审核
  operateList:()=>import('@/views/reportList/operateList'),
  scanList:()=>import('@/views/reportList/scanList'),
  scanListFlow:()=>import('@/views/reportList/scanListFlow'),
  //抽奖
  lottery:()=>import('@/views/lottery/lotteryIndex'),           //抽奖活动
  lotteryIndex:()=>import('@/views/lottery/lotteryIndex'),
  lotteryList:()=>import('@/views/lottery/lotteryList'),         //登记记录

  // 外部订单导入
  tripartiteBiz:()=>import('@/views/tripartiteBiz/orderList'),
  tripartiteOrder:()=>import('@/views/tripartiteBiz/orderList'), // 外部订单管理
  tripartiteTransfer:()=>import('@/views/tripartiteBiz/transferList'), // 外部中转仓管理
  tripartiteFreight:()=>import('@/views/tripartiteBiz/freightList'), // 外部物流单管理
  outRegistLog:()=>import('@/views/reportList/outRegistLogList'),//出门核验

}
// 动态路由转树结构
export function routesToTree(arr) {
  var arrs = []
  arr.forEach(item => {
    item.name = item.title;
    item.hidden = item.hidden == 2 ? true:false;
    item.meta = {
      title: item.title,
      icon: item.icon,
      affix: item.affix == 2 ? true : false,
      noCache: item.noCache == 2 ? true : false
    };
    if (item.parentId==0) {
      arrs.push(item)
    }
  })

  return arr.reduce((h, m) => {
    if (m.parentId != 0) {
      foo(h, m)
    }

    function foo(arr, cur) {
      arr.forEach(item => {
        if (item.id === cur.parentId) {
          if (!item.children) {
            item.children = []
          }
          item.children.push(cur)
        } else if (item.children) {
          foo(item.children, cur)
        }
      })
    }

    return h
  }, arrs)
}

// map对后台数据做路由映射
export function getMapRoutes(menuList){
  if(!menuList&&menuList.length===0)return [];
  menuList.forEach(item=>{
    item.component = routesMap[item.component];
  })
  // return menuList;

  var newMeun = []
  menuList.forEach(item=>{
    if(item.title != "finance" && item.title != "posWithdraw" && item.title != "dailySales" && item.title != "withdrawalIncidental"
      && item.title != "financeLogistics" && item.title != "financeLogisticsDetail" && item.title != "fund" && item.title != "fundDaily" && item.title != "capitalDaily"
      && item.title != "shopDaily" && item.title != "categorySum" && item.title != "serviceRate" && item.title != "productSales"
      && item.title != "shopWithdrawalSum" && item.title != "productWithdrawalSum" && item.title != "productWithdrawalDetail") {
      // console.log(item)
      newMeun.push(item)
    }
  })
  return newMeun;
}



// WEBPACK FOOTER //
// ./src/router/asyncRoutes.js